import { Outlet } from 'react-router-dom'

import Loading from 'modules/core/components/Loading'
import NotFound from 'modules/core/components/NotFound'
import { useTicketingPolicies } from 'modules/ticketing/hooks/useTicketingPolicies'

const RootPage = () => {
  const { loading, canViewTicketing } = useTicketingPolicies()

  if (loading) return <Loading />
  if (!canViewTicketing) return <NotFound />

  return <Outlet />
}

export default RootPage
